import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../common/LoadingPanel";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../common/Localization";
import DialogWindow from "../common/DialogWindow.js";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { nahlasenieDodavkyController } from "../../controllers/nahlaseniedodavky.controller";
import confirmService from "../common/confirmService";
import { dateConvert } from "../common/Helpers";
import NahlasenieKusyDialogContent from "./RucniNahlasenieDodavky/NahlasenieKusyDialogContent";
import DetailDodavkyDialogContent from "./DetailDodavkyDialogContent";
import Moment from "moment";
import { authenticationService } from "../../services/authentication.service";
import { ButtonGroupEnum, ButtonMessageEnum, MessageTypeEnum, RoleNames } from "../../enums";

class RucniNahlDodavkyDialogContent extends Component {
    state = {
        loading: true,
        dialog: {
            title: null,
            content: null,
            width: null,
            height: null
        }
    };

    componentDidMount() {
        nahlasenieDodavkyController.getDodavkyProRucniNahlasenie().then(async response => {
            if (response.isError) {
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message: "Chyba nacteni zaznamu pro rucni nahlasenie: " + response.errorMessage,
                    logMessage: true
                });
                this.props.toggleDialog();
            }
            let data = JSON.parse(JSON.stringify(response), dateConvert);
            this.setState({
                loading: false,
                data: data
            });
        });
    }

    nahlasitDodavku = async () => {
        var localizationService = provideLocalizationService(this);

        var dodavka = this.state.selectedDodavka;
        if (!dodavka) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "PríjemDod.Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !",
                    "Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !"
                )
            });
            return;
        }

        // If Nastavenia_GET(nstChybaPoslednýImport, True) = True Then
        //     MsgBox "Nie je možné nahlásiť dodávku !" & vbCrLf & vbCrLf & "Nastali problémy pri poslednom importe dávky v maloobchode." _
        //             & vbCrLf & vbCrLf & "Kontaktujte správcu databázy !", vbExclamation
        //     Exit Sub
        // End If

        this.setState({
            nahlasitDodavkuDisabled: true
        });

        if (dodavka.skladFrom === 91 || (dodavka.skladFrom === 1 && dodavka.cisloDodavky >= 20000 && dodavka.cisloDodavky <= 39999)) {
            nahlasenieDodavkyController.nahlaseniDodavkyDachser(dodavka.idExpedicia, dodavka.cisloDodavky, dodavka.skladFrom).then(async (response) => {
                this.setState({
                    nahlasitDodavkuDisabled: false
                });

                if (response.isError) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: response.errorMessage,
                        logMessage: true
                    });
                    return;
                }
                if (response.msgBoxChyba) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        width: "700px",
                        message: response.msgBoxChyba,
                        logMessage: true
                    });
                }

                if (response.msgBoxNaviac) {
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: response.msgBoxNaviac,
                        logMessage: true
                    });
                }
                this.openDialogNahlaseniKusy(response);
            });
        } else {
            var dodavkaInfo = await nahlasenieDodavkyController.getNahlasenaDodavkaInfo(dodavka.idDodavka, dodavka.skladFrom);
            if (dodavkaInfo.isError) {
                await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: dodavkaInfo.errorMessage,
                    logMessage: true
                });
                this.setState({
                    nahlasitDodavkuDisabled: false
                });
                return;
            }

            if (dodavkaInfo.jeDodavkaNahlasena) {
                var msg1 = localizationService
                    .toLanguageString("PríjemDod.Dodávka č.{0} z {1} už bola nahlásená !", "Dodávka č.{0} z {1} už bola nahlásená !")
                    .replace("{0}", dodavka.cisloDodavky || "")
                    .replace("{1}", dodavkaInfo.skladNazov || "");

                var msg2 = localizationService.toLanguageString("PríjemDod.Chcete zmeniť nahlásenie ?", "Chcete zmeniť nahlásenie ?");

                const confirmResult = await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: msg1 + "\r\n\r\n" + msg2,
                    buttons: ButtonGroupEnum.OK_CANCEL,
                    logMessage: true
                });

                this.setState({
                    nahlasitDodavkuDisabled: false
                });

                if (confirmResult == ButtonMessageEnum.OK) {
                    nahlasenieDodavkyController.nahlaseniPresuny(false, dodavka.idExpedicia, dodavka.cisloDodavky, dodavka.skladFrom).then(async (response) => {
                        if (response.isError) {
                            await confirmService.show({
                                type: MessageTypeEnum.EXCLAMATION,
                                message: response.errorMessage,
                                logMessage: true
                            });
                        } else {
                            this.reloadGrids();
                        }
                    });
                }
            } else {
                var jeAdmin = authenticationService.hasCurrentUserRole(RoleNames.Administrator);
                var podminka1 = !jeAdmin; /*&& DBSapp.AutomatickyNahlasovaťPresuny = True*/
                //'musí byť naskenované všetky balíky
                var podminka2 = !jeAdmin && (dodavkaInfo.pocetBalikov != dodavkaInfo.naskenovanychBalikov || dodavkaInfo.pocetBalikov <= 0);
                if (podminka1 || podminka2) {
                    var msg1 = localizationService.toLanguageString(
                        "PríjemDod.Tento typ dodávky sa nahlasuje automaticky po naskenovaní balíkov !",
                        "Tento typ dodávky sa nahlasuje automaticky po naskenovaní balíkov !"
                    );
                    var msg2 = localizationService.toLanguageString(
                        "PríjemDod.Ak balíky chýbajú a už neprídu, pre nahlásenie dodávky kontaktujte technickú podporu.",
                        "Ak balíky chýbajú a už neprídu, pre nahlásenie dodávky kontaktujte technickú podporu."
                    );
                    await confirmService.show({
                        type: MessageTypeEnum.EXCLAMATION,
                        message: msg1 + "\r\n\r\n" + msg2,
                        logMessage: true
                    });
                    this.setState({
                        nahlasitDodavkuDisabled: false
                    });
                    return;
                }
                const confirmResult = await confirmService.show({
                    type: MessageTypeEnum.EXCLAMATION,
                    message: localizationService
                        .toLanguageString("PríjemDod.Chcete nahlásiť dodávku č.{0} z {1} ?", "Chcete nahlásiť dodávku č.{0} z {1} ?")
                        .replace("{0}", dodavka.cisloDodavky || "")
                        .replace("{1}", dodavkaInfo.skladNazov || ""),
                    buttons: ButtonGroupEnum.OK_CANCEL,
                    logMessage: true
                });

                this.setState({
                    nahlasitDodavkuDisabled: false
                });

                if (confirmResult == ButtonMessageEnum.OK) {
                    nahlasenieDodavkyController.nahlaseniPresuny(true, dodavka.idExpedicia, dodavka.cisloDodavky, dodavka.skladFrom).then(async (response) => {
                        if (response.isError) {
                            await confirmService.show({
                                type: MessageTypeEnum.EXCLAMATION,
                                message: response.errorMessage,
                                logMessage: true
                            });
                        } else {
                            this.reloadGrids();
                        }
                    });
                }
            }
        }
    };

    reloadGrids() {
        this.props.reloadNahlasNenahlasDodavkyGrid();
        this.props.reloadSpravyGrid();
        this.props.toggleDialog();
    }

    openDialogNahlaseniKusy(dodavka) {
        var localizationService = provideLocalizationService(this);
        var title = localizationService
            .toLanguageString("RucniNahl.Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>", "Nenahlášené dodávky č. <P1>, odesílatel <P2> ze dne <P3>")
            .replace("<P1>", dodavka.cisloDodavky || "")
            .replace("<P2>", dodavka.odosilatel || "")
            .replace("<P3>", Moment(dodavka.datumExpedicie).format("D.M.YYYY") || "");

        this.setState({
            dialog: {
                title: title,
                hasClosingConfirmDialog: true,
                content: onClose => (
                    <NahlasenieKusyDialogContent
                        toggleDialog={this.props.toggleDialog}
                        dodavka={dodavka}
                        reloadSpravyGrid={this.props.reloadSpravyGrid}
                        reloadNahlasNenahlasDodavkyGrid={this.props.reloadNahlasNenahlasDodavkyGrid}
                    />
                ),
                height: "600px",
                width: "1000px"
            }
        });
    }

    changeTitle = title => {
        var dialogProperty = { ...this.state.dialog };
        dialogProperty.title = title;
        this.setState({ dialog: dialogProperty });
    };

    openDetailDodavky = async iddodavka => {
        var localizationService = provideLocalizationService(this);

        var dodavka = this.state.selectedDodavka;
        if (!dodavka) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "PríjemDod.Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !",
                    "Vyberte dodávku zo zoznamu nenahlásených dodávok tovaru !"
                )
            });
            return;
        }

        this.setState({
            dialog: {
                title: localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Dodávka", "Dodávka"),
                content: () => <DetailDodavkyDialogContent selectedDodavkaId={iddodavka} changeTitle={this.changeTitle} />,
                height: "90%",
                width: "90%"
            }
        });
    };

    handleClickNahlasenie = () => {
        this.openDetailDodavky(this.state.selectedIdDodavka);
    };

    renderDialogContent(items) {
        var localizationService = provideLocalizationService(this);
        return (
            <div id="RucniNahlDodavkyDialog" onMouseDown={e => e.preventDefault() /* prevents browser text selection */}>
                <Grid
                    data={items.value.map(item => ({ ...item, selected: item.idDodavka === this.state.selectedIdDodavka }))}
                    selectedField="selected"
                    onRowClick={e => {
                        this.setState({ selectedIdDodavka: e.dataItem.idDodavka, selectedDodavka: e.dataItem });
                    }}>
                    <GridColumn
                        field="datum"
                        title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Expedované", "Expedované")}
                        format="{0:d.M.yyyy}"
                        width="80px"
                    />
                    <GridColumn field="nazov" title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Odosielateľ", "Odosielateľ")} />
                    <GridColumn
                        field="cisloDodavky"
                        title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Dodávka", "Dodávka")}
                        width="70px"
                    />
                    <GridColumn field="sposobDopravy" title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Doprava", "Doprava")} />
                    <GridColumn
                        field="pocetBalikov"
                        title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Balíkov-Lotov-Kusov", "Balíkov-Lotov-Kusov")}
                    />
                    <GridColumn field="pocetKs" title={localizationService.toLanguageString("NahlasenieNenahlaseneDodavky.Grid.Kusov", "Kusov")} />
                </Grid>
                <div className="grid-button-bar row">
                    <div className="col-sm-6">
                        <Button onClick={this.handleClickNahlasenie}>
                            <Localization
                                messageKey={"PríjemDod.Balíky, artikle a rozdiely v dodávke"}
                                defaultMessage={"Balíky, artikle a rozdiely v dodávke"}
                            />
                        </Button>
                    </div>
                    <div className="col-sm-6 text-right">
                        <Button onClick={this.nahlasitDodavku} disabled={this.state.nahlasitDodavkuDisabled} className="font-bold">
                            <Localization messageKey={"PríjemDod.Nahlásiť dodávku"} defaultMessage={"Nahlásiť dodávku"} />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent(this.state.data);

        return (
            <div>
                {contents}
                <DialogWindow dialog={this.state.dialog} />
            </div>
        );
    }
}

export default RucniNahlDodavkyDialogContent;

registerForLocalization(RucniNahlDodavkyDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/RucniNahlDodavkyDialogContent.js